var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.wrapperType,{tag:"component",attrs:{"to":_vm.imageLink}},[_c('nuxt-img',{attrs:{"src":_vm.imageSrc,"width":"400","alt":_vm.mediaMeta.alt,"title":_vm.mediaMeta.title}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }